<template>
  <svg
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 5.5L0 0.5L8 0.5L4 5.5Z" fill="white" />
  </svg>
</template>
